import React from "react";
import ControlTemplate from "../BaseControls/ControlTemplate";
import {controlPropTypes} from "../formhelpers";

export default class Label extends React.Component {
    render() {
        const {value} = this.props;
        return (
            <ControlTemplate {...this.props} className="string-field" >
                <span>{value}</span>
            </ControlTemplate>
        );
    }
}

Label.propTypes = controlPropTypes();



// WEBPACK FOOTER //
// ./app/lib/common/descriptorcontrols/StringField/label.js